import { ChainRpcProps } from "types/baseType"

const chainRpcs: {[key: string]: ChainRpcProps} = {
    // FSN
    "32659":{
        "rpcUrl":"https://mainnet.fusionnetwork.io",
        "scanUrl":"https://fsnscan.com",
        "address": "0x3668c219b1FA8Fe8175158F6ce91ded36fdE9152",
        "swapAddress": "0xAf5A8CbCCE58267D05577a560D04b51D46dCc124"
    },
    // ETH
    "1":{
        "rpcUrl":"https://rpc.ankr.com/eth",
        "scanUrl":"https://etherscan.io",
        "address": "0x4c5F53015f3aDB1b1d15DDf4e17edAaE6fA185A5",
        "swapAddress": "0x850d5097a9970Dda56EF7067d79cA9aC5834450F"
    },
    // BNB
    "56":{
        "rpcUrl":"https://rpc.ankr.com/bsc",
        "scanUrl":"https://bscscan.com",
        "address": "0x99A57AC044e6Ce44b7E161a07Af0d3e693a75b54",
        "swapAddress": "0xBFFcA20712e0906D1ef74F3E0A7cBE050AA6228A"
    },
    // HT
    "128":{
        "rpcUrl":"https://http-mainnet.hecochain.com",
        "scanUrl":"https://www.hecoinfo.com/en-us",
        "address": "",
        "swapAddress": ""
    },
    // OKC
    "66":{
        "rpcUrl":"https://exchainrpc.okex.org",
        "scanUrl":"https://www.oklink.com/en/okc",
        "address": "",
        "swapAddress": ""
    },
    // AVAXC
    "43114":{
        "rpcUrl":"https://rpc.ankr.com/avalanche",
        "scanUrl":"https://snowtrace.io",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c"
    },
    // FTM
    "250":{
        "rpcUrl":"https://rpc.ankr.com/fantom",
        "scanUrl":"https://ftmscan.com",
        "address": "0x2e2c52d8143a0D0c34bd4d6C1Fd49ff6Cc9152bd",
        "swapAddress": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158"
    },
    // ETC
    "61":{
        "rpcUrl":"https://www.ethercluster.com/etc",
        "scanUrl":"https://www.oklink.com/en/etc",
        "address": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158",
        "swapAddress": ""
    },
    // ETHW
    "10001":{
        "rpcUrl":"https://mainnet.ethereumpow.org",
        "scanUrl":"https://www.oklink.com/en/ethw",
        "address": "",
        "swapAddress": ""
    },
    // ETHF
    "513100":{
        "rpcUrl":"https://rpc.etherfair.org",
        "scanUrl":"https://www.oklink.com/en/ethf",
        "address": "",
        "swapAddress": ""
    },
    // FUSE
    "122":{
        "rpcUrl":"https://fuse-pokt.nodies.app",
        "scanUrl":"https://explorer.fuse.io/",
        "address": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c",
        "swapAddress": ""
    },
    // POLYGON
    "137":{
        "rpcUrl":"https://rpc.ankr.com/polygon",
        "scanUrl":"https://polygonscan.com",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x3e87e672df45a4a15d25d490b7c42f0545223ca7"
    },
    // AURORA
    "1313161554":{
        "rpcUrl":"https://mainnet.aurora.dev",
        "scanUrl":"https://aurorascan.dev",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c"
    },
    // CAD
    "256256": {
        "rpcUrl":"https://mainnet.block.caduceus.foundation",
        "scanUrl":"https://mainnet.scan.caduceus.foundation/",
        "address": "",
        "swapAddress": ""
    },
    // METIS
    "1088":{
        "rpcUrl":"https://andromeda.metis.io/?owner=1088",
        "scanUrl":"https://andromeda-explorer.metis.io",
        "address": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c",
        "swapAddress": ""
    },
    // CIC
    "1353":{
        "rpcUrl":"https://xapi.cicscan.com",
        "scanUrl":"https://cicscan.com/",
        "address": "",
        "swapAddress": ""
    },
    // RSK
    "30":{
        "rpcUrl":"https://public-node.rsk.co",
        "scanUrl":"https://explorer.rsk.co",
        "address": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c",
        "swapAddress": ""
    },
    // TARA
    "841":{
        "rpcUrl":"https://rpc.mainnet.taraxa.io",
        "scanUrl":"https://mainnet.explorer.taraxa.io",
        "address": "",
        "swapAddress": ""
    },
    // KLAY
    "8217":{
        "rpcUrl":"https://cypress.fandom.finance/archive",
        "scanUrl":"https://scope.klaytn.com",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c"
    },
    // CRO
    "25":{
        "rpcUrl":"https://evm-cronos.crypto.org",
        "scanUrl":"https://cronoscan.com",
        "address": "",
        "swapAddress": ""
    },
    // CANTO
    "7700":{
        "rpcUrl":"https://canto.slingshot.finance",
        "scanUrl":"https://evm.explorer.canto.io",
        "address": "0x9F9cd69e9416F9F87a197eEA5B8B98E009Dd29dB",
        "swapAddress": ""
    },
    // CORE
    "1116":{
        "rpcUrl":"https://rpc.coredao.org",
        "scanUrl":"https://scan.coredao.org",
        "address": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c",
        "swapAddress": ""
    },
    // ELA
    "20":{
        "rpcUrl":"https://rpc.glidefinance.io",
        "scanUrl":"https://eth.elastos.io",
        "address": "0xc66E5E278B24aDbB638cBa30D6E6de697F73a774",
        "swapAddress": ""
    },
    // CFXEVM
    "1030": {
        "rpcUrl":"https://evm.confluxrpc.com",
        "scanUrl":"https://evm.confluxscan.net/",
        "address": "",
        "swapAddress": ""
    },
    // SYSEVM
    "57":{
        "rpcUrl":"https://rpc.syscoin.org",
        "scanUrl":"https://explorer.syscoin.org",
        "address": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158",
        "swapAddress": ""
    },
    // FEVM
    "314":{
        "rpcUrl":"https://rpc.ankr.com/filecoin",
        "scanUrl":"https://filscan.io",
        "address": "",
        "swapAddress": ""
    },
    // TELOSEVM
    "40": {
        "rpcUrl":"https://mainnet.telos.net/evm",
        "scanUrl":"https://www.teloscan.io/",
        "address": "",
        "swapAddress": ""
    },
    // ARB
    "42161":{
        "rpcUrl":"https://rpc.ankr.com/arbitrum",
        "scanUrl":"https://arbiscan.io",
        "address": "0xF422Ec7591e83612A39DBdf94563F20133ef2d9F",
        "swapAddress": "0x88aCd533fD20Bc345f9afE640707f406b0e02552",
    },
    // OP
    "10":{
        "rpcUrl":"https://opt-mainnet.g.alchemy.com/v2/JzmIL4Q3jBj7it2duxLFeuCa9Wobmm7D",
        "scanUrl":"https://optimistic.etherscan.io",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c"
    },
    // BASE
    "8453":{
        "rpcUrl":"https://mainnet.base.org",
        "scanUrl":"https://basescan.org",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c"
    },
    // LINEA
    "59144":{
        "rpcUrl":"https://rpc.linea.build",
        "scanUrl":"https://lineascan.build/",
        "address": "0x9336Cc0e8C14c7ed7D1dEE4367B157250Dc17852",
        "swapAddress": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158"
    },
    // ZKEVM
    "1101":{
        "rpcUrl":"https://polygon-zkevm.blockpi.network/v1/rpc/public",
        "scanUrl":"https://zkevm.polygonscan.com",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c"
    },
    // ZKSYNC
    "324":{
        "rpcUrl":"https://mainnet.era.zksync.io",
        "scanUrl":"https://www.oklink.com/cn/zksync",
        "address": "0xad6551B130F3BCF6c43B0a3E9A813a3dA0B4f80A",
        "swapAddress": "0x90828fc8a8e53739f477c3478a5c5d3f007b6b00"
    },
    // OPBNB
    "204":{
        "rpcUrl":"https://opbnb.publicnode.com",
        "scanUrl":"https://opbnbscan.com",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": ""
    },
    // ROLLUX
    "570":{
        "rpcUrl":"https://rpc.rollux.com",
        "scanUrl":"https://explorer.rollux.com",
        "address": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158",
        "swapAddress": ""
    },
    // CUBE
    "1818":{
        "rpcUrl":"https://http-mainnet-archive.cube.network",
        "scanUrl":"https://www.cubescan.network/en-us",
        "address": "",
        "swapAddress": ""
    },
    // SHIBA
    "109":{
        "rpcUrl":"https://www.shibrpc.com",
        "scanUrl":"https://www.shibariumscan.io",
        "address": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158",
        "swapAddress": ""
    },
    // SCROLL
    "534352":{
        "rpcUrl":"https://scroll-mainnet.public.blastapi.io",
        "scanUrl":"https://blockscout.scroll.io/",
        "address": "0x9336Cc0e8C14c7ed7D1dEE4367B157250Dc17852",
        "swapAddress": "0x902a39Be637FFB553B08Db92FF64b5bCB7d32158"
    },
    // MERLIN
    "4200":{
        "rpcUrl":"https://rpc.merlinchain.io",
        "scanUrl":"https://scan.merlinchain.io/",
        "address": "0x789b80d08bA14DB8510EAab7E32E703b31fb572c",
        "swapAddress": ""
    },
    // BLAST
    "81457": {
        "rpcUrl":"https://rpc.ankr.com/blast",
        "scanUrl":"https://blastscan.io/",
        "address": "0x0b662D54824825725BE1E76C0a2B1c8F49b7419b",
        "swapAddress": ""
    },
    // XLAYER
    "196": {
        "rpcUrl":"https://rpc.xlayer.tech",
        "scanUrl":"https://www.okx.com/explorer/xlayer/",
        "address": "0x9a26783c35e4f8e4e24e06372a94d9cffb3c39fa",
        "swapAddress": ""
    },
    // B2
    "223": {
        "rpcUrl":"https://rpc.bsquared.network",
        "scanUrl":"https://explorer.bsquared.network/",
        "address": "0xb712d62fe84258292d1961b5150a19bc4ab49026",
        "swapAddress": ""
    },
    // BTR
    "200901": {
        "rpcUrl":"https://rpc.bitlayer.org",
        "scanUrl":"https://www.btrscan.com/",
        "address": "0x3e87e672df45a4a15d25d490b7c42f0545223ca7",
        "swapAddress": ""
    }
}

export default chainRpcs